import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ClutchIcon } from "../../../app-constants";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "gatsby";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1801 },
    items: 2.1,
  },
  desktop: {
    breakpoint: { max: 1800, min: 1600 },
    items: 1.8,
  },
  smalldesktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 1.65,
  },
  landscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 1.8,
  },
  tablet: {
    breakpoint: { max: 1199, min: 900 },
    items: 1.4,
  },
  mobilelg: {
    breakpoint: { max: 899, min: 667 },
    items: 1.1,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 1,
  },
};

const Associatesslider = (props) => {
  return (
    <div className="associatesslider p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={8}
            xl={8}
            xxl={8}
            className="text-center m-auto"
          >
            <h2>
              Feedback We Bagged on Our <span>2D Game Development</span>{" "}
              Services
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={3000}
              showDots={false}
              arrows={false}
            >
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Stephanie Berman
                    <span>CEO & Founder ,Engagement Through Education</span>
                  </div>
                  <p>"Everything has been flowing pretty smoothly."</p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=2#review-1831525"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>4.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Brian Ferguson
                    <span> Executive Director, Project Impact Mississippi</span>
                  </div>
                  <p>
                    "It’s been an awesome experience. It feels like we’re a
                    family."
                  </p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=3#review-1686308"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>5.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Cameron Maxey<span>Co-Founder, Younit</span>
                  </div>
                  <p>"Their communication has been great."</p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=3#review-1559616"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>5.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Associatesslider;
